<template>
  <div class="w-full h-[565px] bg-white flex flex-col items-center justify-center px-8">
    <div class="text-center max-w-md">
      <h3 class="text-2xl font-semibold text-gray-800 mb-3">
        {{ title }}
      </h3>

      <p class="text-gray-500 text-base mb-8">
        {{ subtitle }}
      </p>

      <button
          v-if="buttonText && buttonRoute"
          @click="handleButtonClick"
          class="px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors font-medium"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    required: true
  },
  buttonText: {
    type: String,
    default: ''
  },
  buttonRoute: {
    type: String,
    default: ''
  }
});

const handleButtonClick = () => {
  if (props.buttonRoute) {
    window.location.href = route(props.buttonRoute);
  }
};
</script>